/**
 * 샌드버드 platform API Util
 */
class RestSb {
  // TODO 숨기기
  static TOKEN = ''
  static APP_ID = ''

  static getApiHeader() {
    const header = {};
    header['Content-Type'] = 'application/json, charset=utf8';
    header['Api-Token'] = this.TOKEN;
    return header;
  }

  static getUrl(url) {
    const urlBase = "https://api-" + this.APP_ID + ".sendbird.com/v3";
    if (!url || typeof url !== 'string') {
      throw new Error('url is illegal');
    }
    if (url.indexOf('http') < 0) {
      if (url[0] !== '/') {
        url = '/' + url;
      }
      return urlBase + url;
    }
    return url;
  }

  /**
   *
   * @param url
   * @param {*?} data
   * @returns {Promise}
   */
  static get(url, data) {
    return $.ajax({
      headers: this.getApiHeader(),
      method: 'GET',
      url: this.getUrl(url),
      data: data,
      cache: false,
    });
  }

  /**
   *
   * @param url
   * @param {*?} data
   * @returns {Promise}
   */
  static put(url, data) {
    return $.ajax({
      headers: this.getApiHeader(),
      method: 'PUT',
      url: this.getUrl(url),
      data: JSON.stringify(data),
      cache: false,
    });
  }

  /**
   *
   * @param url
   * @param {*?} data
   * @returns {Promise}
   */
  static post(url, data) {
    return $.ajax({
      headers: this.getApiHeader(),
      method: 'POST',
      url: this.getUrl(url),
      data: JSON.stringify(data),
      cache: false,
    });
  }

  /**
   *
   * @param url
   * @returns { Promise }
   */
  static delete(url) {
    return $.ajax({
      headers: this.getApiHeader(),
      method: 'DELETE',
      url: this.getUrl(url),
      cache: false,
    });
  }
}

/**
 * 샌드버드 platform API
 */
class ApiSb extends RestSb {
  static test() {
    return this.get('/');
  }

  static sendbirdGetUser(userId) {
    return this.get('users/' + encodeURIComponent(userId));
  }

  static sendbirdCreateUser(items) {
    return this.post('users', items);
  }

  static sendbirdUpdateUser(items) {
    return this.put('users/' + items.user_id, items);
  }

  static sendbirdSendMessage(items) {
    const data = {
      'message_type': 'MESG',
      'user_id': items.sender,
      'message': items.message
    };
    return this.post(items.channelType + '/' + items.channelUrl + '/messages', data);
  }
  
  /**
   * 그룹 채널 갯수
   * @param userId
   * @returns {Promise} { 'group_channel_count': 123 }
   */
  static getGroupChannelCount(userId) {
    return this.get(`users/${userId}/group_channel_count`);
  }

  /**
   * 사용자 이름 검색
   * @param name
   * @param {String?} pageToken
   * @returns {Promise}
   */
  static searchUsers(name, pageToken) {
    let url = 'users?limit=50&nickname_startswith=' + encodeURIComponent(name);
    if (pageToken) {
      url = url + 'token=' + pageToken;
    }
    return this.get(url)
  }

  /**
   * 그룹채널 검색
   * @param {string} userId 꼭 포함되어야 할 userId
   * @param {number} createdAfter milliseconds
   * @param {number} createdBefore  milliseconds
   * @param {String?} pageToken
   * @returns {Promise}
   * @See https://sendbird.com/docs/chat/v3/platform-api/user/managing-joined-group-channels/list-group-channels
   */
  static searchGroupChannelList(userId, createdAfter, createdBefore, pageToken) {
    let url = 'users/' + userId + '/my_group_channels?limit=50' +
      '&created_after=' + createdAfter +
      '&created_before=' + createdBefore +
      '&order=latest_last_message' +
      '&distinct_mode=distinct' +
      '&show_empty=true' +
      '&show_member=true';

    if (pageToken) {
      url = url + '&token=' + pageToken;
    }
    return this.get(url);
  }
}